module.exports = __webpack_public_path__ + "media/images/undraw/psc/firmware-875734d08301b4510669d3bf0defba25.png";